module.exports = __webpack_public_path__ + "media/images/help/team-create-f0f812148f04b9f3d57d79ded5b41741.png";